import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/CopyrightPolicy.css';

const CopyrightPolicy = () => {
  return (
    <div className="copyright-policy">
      <div className="container">
        <h1>Copyright & DMCA Policy</h1>
        <p className="last-updated">Last updated: January 10, 2026</p>

        <section className="section">
          <h2>1. Intellectual Property Rights</h2>
          <p>Falphin respects intellectual property rights and expects its users to do the same. When you upload content to Falphin, you retain all ownership rights to your original work.</p>
          <p><strong>Important:</strong> By uploading content to Falphin, you represent and warrant that you own or have the necessary rights, licenses, and permissions to distribute the content worldwide.</p>
        </section>

        <section className="section">
          <h2>2. Copyright Infringement Claims</h2>
          <p>If you believe that your copyrighted work has been copied and is accessible on Falphin in a way that constitutes copyright infringement, you may notify our designated agent as set forth in the Digital Millennium Copyright Act of 1998 (DMCA).</p>
          
          <h3>To file a copyright infringement notification with us, you will need to send a written communication that includes:</h3>
          <ol>
            <li>A physical or electronic signature of a person authorized to act on behalf of the copyright owner</li>
            <li>Identification of the copyrighted work claimed to have been infringed</li>
            <li>Identification of the material that is claimed to be infringing and that is to be removed</li>
            <li>Information reasonably sufficient to permit us to contact you (email address, telephone number, etc.)</li>
            <li>A statement that you have a good faith belief that use of the material is not authorized by the copyright owner</li>
            <li>A statement that the information in the notification is accurate, and under penalty of perjury, that you are authorized to act on behalf of the copyright owner</li>
          </ol>
        </section>

        <section className="section">
          <h2>3. Counter-Notification</h2>
          <p>If you believe that your content was removed or disabled as a result of a mistake or misidentification, you may submit a counter-notification that includes:</p>
          <ol>
            <li>Your physical or electronic signature</li>
            <li>Identification of the material that has been removed or disabled</li>
            <li>A statement under penalty of perjury that you have a good faith belief the material was removed or disabled as a result of mistake or misidentification</li>
            <li>Your name, address, and telephone number</li>
            <li>A statement that you consent to the jurisdiction of the Federal District Court for the judicial district in which your address is located</li>
          </ol>
        </section>

        <section className="section">
          <h2>4. Repeat Infringer Policy</h2>
          <p>In accordance with the DMCA and other applicable laws, Falphin has adopted a policy of terminating, in appropriate circumstances and at our sole discretion, users who are deemed to be repeat infringers. We may also limit access to the service and/or terminate the accounts of any users who infringe any intellectual property rights of others, whether or not there is any repeat infringement.</p>
        </section>

        <section className="section">
          <h2>5. Copyright Agent</h2>
          <p>All claims of copyright infringement should be sent to our designated copyright agent:</p>
          <div className="contact-box">
            <p><strong>Copyright Agent</strong><br />
            Falphin<br />
            Email: <a href="mailto:copyright@falphin.com">copyright@falphin.com</a></p>
            <p><strong>Note:</strong> This email address is for copyright infringement notices only. For other inquiries, please use our <Link to="/contact">contact form</Link>.</p>
          </div>
        </section>

        <section className="section">
          <h2>6. False Notices</h2>
          <p>Please note that under Section 512(f) of the DMCA, any person who knowingly materially misrepresents that material or activity is infringing may be subject to liability. Be sure to consider whether fair use, fair dealing, or a similar exception to copyright applies before sending a notice.</p>
        </section>

        <section className="section">
          <h2>7. Changes to This Policy</h2>
          <p>We may update our Copyright Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date.</p>
        </section>
      </div>
    </div>
  );
};

export default CopyrightPolicy;
